import { GeneratorBannerObj } from './types'
import { PrismicAPIResp } from '../HomepageStaticContent/types'
import { parseGeneratorBannerData } from './utils'
import { useMemo } from 'react'

export const useGeneratorBannerData = (
  data: PrismicAPIResp[]
): {
  generatorBannerDesktopData: GeneratorBannerObj['generator_banner_desktop']
  generatorBannerMobileData: GeneratorBannerObj['generator_banner_mobile']
} => {
  const {
    generator_banner_desktop: generatorBannerDesktopData,
    generator_banner_mobile: generatorBannerMobileData
  } = useMemo(() => parseGeneratorBannerData(data), [data])
  return {
    generatorBannerDesktopData,
    generatorBannerMobileData
  }
}
